import script from "./diamondsSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./diamondsSearch.vue?vue&type=script&setup=true&lang=ts"

import "./diamondsSearch.vue?vue&type=style&index=0&id=5c92ab66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c92ab66"]])

export default __exports__